function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCustomer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shopping_x5F_customer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.043 32",
    style: {
      enableBackground: "new 0 0 28.043 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "24.469,31.895 23.574,30.105 25.276,29.255 26,27.808 25.043,17.278 24.34,15.873  15.021,13.802 15.021,9 16.607,9 18.021,7.586 18.021,3.414 16.607,2 11.436,2 10.021,3.414 10.021,7.586 11.436,9 13.021,9  13.021,13.802 3.703,15.873 3,17.278 2.043,27.808 2.767,29.255 4.469,30.105 3.574,31.895 1.276,30.745 0,28.192 1.043,16.722  2.34,14.127 11.021,12.198 11.021,11 10.607,11 8.021,8.414 8.021,2.586 10.607,0 17.436,0 20.021,2.586 20.021,8.414 17.436,11  17.021,11 17.021,12.198 25.703,14.127 27,16.722 28.043,28.192 26.767,30.745  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.021,
    y: 30,
    style: {
      fill: "#FD5C3F"
    },
    width: 16,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M7.021,28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M21.021,28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "8.021,29 6.021,29 6.021,28.062 5.029,20.124 7.014,19.876 8.021,28  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "22.021,29 20.021,29 20.029,27.876 21.029,19.876 23.014,20.124 22.021,28.062  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.021,
    y: 18,
    style: {
      fill: "#FD5C3F"
    },
    width: 14,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M7.021,20h-2c0-1.103,0.897-2,2-2V20z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M23.021,20l-2-0.002V18C22.124,18,23.021,18.897,23.021,20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCustomer);
export default __webpack_public_path__ + "static/media/shopping_customer.c94e738ebe3dcd806a3606df9e34686a.svg";
export { ForwardRef as ReactComponent };